import * as React from 'react'

import { Avatar, Box, Button, List, Tag, Text } from '@factorialco/deprecated-design-system'
import { GetCalendarSyncsDocument } from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useQuery } from 'modules/core/hooks/useQuery'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { ConfirmRevokeAccessModal, useRevokeAccess } from 'modules/cronofy/components/RevokeAccess'
import { isConnected } from 'modules/cronofy/lib/utils/calendarSync'

import { CalendarSyncsListSkeleton } from './CalendarSyncsListSkeleton'

export const CalendarSyncsList = () => {
  const { data, loading } = useQuery(GetCalendarSyncsDocument)
  const {
    mustConfirm,
    openConfirmModal,
    closeConfirmModal,
    cancelInvite,
    revokeAccess,
    processing,
  } = useRevokeAccess()

  if (loading) return <CalendarSyncsListSkeleton />

  const calendarSyncs = data?.cronofyScheduling.calendarSyncsConnection.nodes

  if (!calendarSyncs || !calendarSyncs.length) {
    return (
      <Box textAlign="center" padding="s48">
        <Text.Normal>{i18n.t('cronofy.calendar_syncs_list.empty_state_message')}</Text.Normal>
      </Box>
    )
  }

  return (
    <>
      <List>
        {calendarSyncs.map((calendarSync) => {
          const connected = isConnected(calendarSync)

          return (
            <List.Item key={calendarSync.id}>
              <List.Title>
                <Box flexDirection="row" alignItems="center" gap="s16">
                  <Avatar
                    label={calendarSync.access.fullName}
                    url={buildUrl(calendarSync.access.avatar)}
                    size="s32"
                  />
                  {calendarSync.access.fullName}
                </Box>
              </List.Title>
              <List.ActionItem>
                <Box flexDirection="row" alignItems="center" gap="s16">
                  <Tag type="correct">
                    {connected
                      ? i18n.t('cronofy.calendar_syncs_list.connected')
                      : i18n.t('cronofy.calendar_syncs_list.invited')}
                  </Tag>
                  <PopoverMenu type="list">
                    <PopoverMenu.Trigger>
                      <Button.Decorative
                        type="secondary"
                        aria-label={i18n.t('cronofy.calendar_syncs_list.more_options')}
                        iconName="ellipsis"
                      />
                    </PopoverMenu.Trigger>
                    <PopoverMenu.Content side="bottom" align="center">
                      <PopoverMenu.TouchableOption
                        title={
                          connected
                            ? i18n.t('cronofy.calendar_syncs_list.revoke_access')
                            : i18n.t('cronofy.calendar_syncs_list.cancel_invite')
                        }
                        onClick={() => {
                          if (connected) {
                            openConfirmModal(calendarSync.id)
                          } else {
                            cancelInvite(calendarSync.id)
                          }
                        }}
                      />
                    </PopoverMenu.Content>
                  </PopoverMenu>
                </Box>
              </List.ActionItem>
            </List.Item>
          )
        })}
      </List>
      <ConfirmRevokeAccessModal
        open={mustConfirm}
        disabled={processing}
        sameUser={false}
        onClose={closeConfirmModal}
        onSubmit={revokeAccess}
      />
    </>
  )
}
